import React from 'react';
import Select from 'react-select';
import { findEmployeeOption, toEmployeeSelectOptions } from '../../../../utils/nozzleEmployeeSelect';

/**
 * Employee dropdown for nozzle allocation. Shows the chosen name after pick
 * (native &lt;select&gt; was snapping back to "Select").
 */
export default function NozzleEmployeeSelect({
	value,
	employees = [],
	onChange,
	name = 'employee_id',
	placeholder = 'Select employee',
	inputId = 'nozzle-employee',
}) {
	const options = toEmployeeSelectOptions(employees);
	const selected = findEmployeeOption(options, value);

	return (
		<Select
			inputId={inputId}
			classNamePrefix="nozzle-employee"
			name={name}
			isSearchable
			isClearable
			placeholder={placeholder}
			options={options}
			value={value ? selected : null}
			onChange={(option) => {
				onChange({
					target: {
						name,
						value: option ? option.value : '',
					},
				});
			}}
			noOptionsMessage={() => 'No employee found'}
			menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
			menuPosition="fixed"
			styles={{
				menuPortal: (base) => ({ ...base, zIndex: 2000 }),
				menu: (base) => ({ ...base, zIndex: 2000 }),
				control: (base) => ({
					...base,
					minHeight: 35,
					background: '#F1F8FF',
					borderColor: '#ced4da',
					fontSize: 13,
				}),
			}}
		/>
	);
}
